import React, { memo } from 'react';
import { TextField, useTranslate } from 'react-admin';
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import DrawerSimpleShowLayout from '../../../../base/components/ra/drawers/DrawerSimpleShowLayout';
import ArrayWithPaginationField from '../../../../base/components/ra/fields/arrayWithPagination.field';

const ExchangeRatesTable = memo(({ record }) => {
  const t = useTranslate();

  return (
    record?.exchangeRates && (
      <Box
        component={DrawerSimpleShowLayout}
        sx={{
          flexGrow: 1,
          bgcolor: 'white',
          borderRadius: 12,
          padding: '24px !important',
        }}
        record={record}
      >
        <Box
          display="flex"
          alignItems="center"
          sx={{
            gap: 4,
          }}
          mb={3}
        >
          <Box component={Typography} variant="h4">
            {t('resources.invoice.exchangeRatesDetails')}
          </Box>
          <Tooltip title={t('resources.invoice.exchangeRatesTooltip')} placement="top-start">
            <IconButton size="small">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <ArrayWithPaginationField
          label={false}
          source="exchangeRates"
          fieldKey="fromCurrencyCode"
          rowsPerPage={[5, 25, 50]}
          defaultPerPage={5}
          style={{
            maxHeight: 'unset',
          }}
        >
          <TextField source="fromCurrencyCode" label="resources.currency.fields.code" />
          <TextField
            source="rate"
            label={t('resources.invoice.fields.exchangeRate', {
              targetCurrency: record?.exchangeRates?.[0]?.toCurrencyCode,
            })}
          />
        </ArrayWithPaginationField>
      </Box>
    )
  );
});

export default ExchangeRatesTable;
